<template>
  <div class="redirecting">
    <p>Redirigiendo...</p>
  </div>
</template>

<script>
import { authStore } from '@/store/auth.js'

export default {
  name: 'AdminLogin',
  mounted() {
    // If already logged in with dashboard access, go straight to dashboard
    if (authStore.isLoggedIn) {
      const user = authStore.currentUser
      if (user.role === 'admin' || (user.permissions || []).includes('analytics')) {
        this.$router.replace('/admin/dashboard')
        return
      }
    }
    // Otherwise redirect to main login with redirect param
    this.$router.replace('/login?redirect=/admin/dashboard')
  }
}
</script>

<style scoped>
.redirecting {
  min-height: 100vh;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 14px;
}
</style>